import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from '@app/shared/layout/header/header.component';
import { FooterComponent } from '@app/shared/layout/footer/footer.component';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ListEventsComponent } from './pages/list-events/list-events.component';

import { EventComponent } from './pages/event/event.component';
import { FormlyModule } from '@ngx-formly/core';
import { ScrollbarComponent } from './pages/event/scrollbar/scrollbar.component';
import { FormlySelectComponent } from './formly/formly-select/formly-select.component';
import { FormlySelectModule } from '@ngx-formly/core/select';
import isEmail from 'validator/lib/isEmail';
import { EditEventComponent } from './modal/edit-event/edit-event.component';
import { SubmitUploadComponent } from '@app/uploads/submit-upload/submit-upload.component';
import { ExportSubtitlesComponent } from './modal/export-subtitles/export-subtitles.component';
import { SearchComponent } from './search/search.component';
import { StenoComponent } from './pages/event/steno/steno.component';
import { NavigationComponent } from './layout/navigation/navigation.component';
import { ButtonComponent } from './button/button.component';
import { EventWrapperComponent } from './pages/event-wrapper/event-wrapper.component';
import { UploadComponent } from './form/upload/upload.component';
import { SettingsComponent } from '@app/stream/settings/settings/settings.component';
import { FilterComponent } from './filter/filter.component';
import { UserChangePasswordComponent } from './modal/user-change-password/user-change-password.component';
import { ModalHeaderComponent } from '@app/shared/modal/modal-header/modal-header.component';
import { ModalBodyComponent } from '@app/shared/modal/modal-body/modal-body.component';
import { ModalFooterComponent } from '@app/shared/modal/modal-footer/modal-footer.component';
import { ModalWrapperComponent } from '@app/shared/modal/modal-wrapper/modal-wrapper.component';
import { ModalBodyTemplateDirective } from '@app/shared/modal/modal-body-template.directive';
import { CheckboxComponent } from './components/form/checkbox/checkbox.component';
import { TextfieldComponent } from './components/form/textfield/textfield.component';
import { DropdownComponent } from './components/form/dropdown/dropdown.component';
import { EventTranscodersComponent } from './pages/event-transcoders/event-transcoders.component';
import { EditUserComponent } from '@app/admin/users-admin/edit-user/edit-user.component';
import { CreateUserComponent } from '@app/admin/users-admin/create-user/create-user.component';
import { MaterialModule } from '@app/material/material.module';
import { ApolloBindingDirective } from '@app/shared/kendo/apollo-binding.directive';
import { ContainerComponent } from './components/container/container.component';
import { StyleguideComponent } from '../styleguide/styleguide.component';
import { FormlyInputComponent } from './formly/formly-input/formly-input.component';
import { MatFileUploadModule } from 'angular-material-fileupload';
import { TableAddRowDirective } from './prime/table-add-row.directive';
import { FileUploadModule } from 'primeng/fileupload';
import { HomeComponent } from '../home/home.component';
import { FormlyAutocompleteComponent } from '@app/shared/formly/formly-autocomplete/formly-autocomplete.component';
import { AdminEditEncoderComponent } from '@app/admin/admin-edit-encoder/admin-edit-encoder.component';
import { TextFieldComponent } from './form/text-field/text-field.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ColorPickerModule } from 'primeng/colorpicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EnableBypassComponent } from './modal/enable-bypass/enable-bypass.component';

export function EmailValidator({ value }) {
  return !value || isEmail(value) ? null : { email: true };
}

export function requiredFieldValidationMessage(err, field) {
  return `${field.templateOptions.label} is required`;
}

export function invalidEmailMessage() {
  return `Invalid email`;
}

const sharedComponents = [
  SettingsComponent,
  DashboardComponent,
  CreateUserComponent,
  EditUserComponent,
  ModalHeaderComponent,
  ModalBodyComponent,
  ModalFooterComponent,
  ModalBodyTemplateDirective,
  ModalWrapperComponent,
  HeaderComponent,
  FooterComponent,
  ListEventsComponent,
  EventComponent,
  ScrollbarComponent,
  ApolloBindingDirective,
  FormlySelectComponent,
  FormlyAutocompleteComponent,
  EditEventComponent,
  EnableBypassComponent,
  SubmitUploadComponent,
  ExportSubtitlesComponent,
  SearchComponent,
  StenoComponent,
  NavigationComponent,
  ButtonComponent,
  EventWrapperComponent,
  UploadComponent,
  FilterComponent,
  UserChangePasswordComponent,
  CheckboxComponent,
  TextfieldComponent,
  DropdownComponent
];

@NgModule({
  entryComponents: [
    SettingsComponent,
    FormlyInputComponent,
    UserChangePasswordComponent,
    FormlySelectComponent,
    EditEventComponent,
    EnableBypassComponent,
    SubmitUploadComponent,
    ExportSubtitlesComponent,
    AdminEditEncoderComponent
  ],
  declarations: [
    ...sharedComponents,
    AdminEditEncoderComponent,
    EventTranscodersComponent,
    ContainerComponent,
    StyleguideComponent,
    FormlyInputComponent,
    TableAddRowDirective,
    HomeComponent,
    TextFieldComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CommonModule,
    MaterialModule,
    RouterModule,
    FormlyModule,
    ReactiveFormsModule,
    FormlySelectModule,
    FormsModule,
    MatFileUploadModule,
    MatTooltipModule,
    FileUploadModule,
    InputSwitchModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    ToolbarModule,
    ColorPickerModule
  ],
  exports: [
    ReactiveFormsModule,
    FormlyModule,
    MaterialModule,
    ...sharedComponents,
    ContainerComponent,
    TableAddRowDirective,
    ColorPickerModule
  ],
  providers: []
})
export class SharedModule {}
